import {
    TextField, MenuItem, Select, InputLabel,
    FormControl, Button, Grid, Typography
} from '@mui/material';
import { useEffect } from 'react';
import permissionProfileStore from '../../Mobx/PermissionProfileStore';

const AccessSerialFilterPanel = ({
    filters, setFilters,
    sortField, setSortField,
    sortOrder, setSortOrder,
    fetchSerials,
    setPage,
    limit,
    setLimit
}) => {
    useEffect(() => {
        permissionProfileStore.fetchProfiles({
            page: 1,
            limit: 1000,
            filters: {},
            sort: [{ field: 'name', order: 'asc' }]
        });
    }, []);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setPage(1);
    };

    const resetFilters = () => {
        setFilters({
            name: '', email: '', serial: '',
            createdAt: { from: '', to: '' },
            permissionProfile: ''
        });
        setPage(1);
    };

    return (
        <Grid container spacing={1} sx={{ padding: 1 }}>
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mb: 1 }}>סינון</Typography>
            </Grid>

            {[
                ['name', 'איש קשר'],
                ['email', 'אימייל'],
                ['serial', 'קוד סיריאל']
            ].map(([key, label]) => (
                <Grid item xs={6} key={key}>
                    <TextField
                        label={label}
                        value={filters[key]}
                        onChange={e => handleChange(key, e.target.value)}
                        size="small"
                        fullWidth
                    />
                </Grid>
            ))}

            {/* סינון לפי פרופיל הרשאות */}
            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>פרופיל הרשאות</InputLabel>
                    <Select
                        value={filters.permissionProfile}
                        onChange={e => handleChange('permissionProfile', e.target.value)}
                        label="פרופיל הרשאות"
                    >
                        <MenuItem value="">הכל</MenuItem>
                        {permissionProfileStore.profiles.map(profile => (
                            <MenuItem key={profile._id} value={profile._id}>
                                {profile.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {/* טווח תאריכים */}
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TextField
                            label="נוצר מתאריך"
                            type="date"
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={filters.createdAt?.from || ''}
                            onChange={e => handleChange('createdAt', {
                                ...filters.createdAt,
                                from: e.target.value
                            })}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label="עד תאריך"
                            type="date"
                            fullWidth
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            value={filters.createdAt?.to || ''}
                            onChange={e => handleChange('createdAt', {
                                ...filters.createdAt,
                                to: e.target.value
                            })}
                        />
                    </Grid>
                </Grid>
            </Grid>

            {/* מיון */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>מיון</Typography>
            </Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>שדה</InputLabel>
                    <Select
                        value={sortField}
                        onChange={e => { setSortField(e.target.value); setPage(1); }}
                        label="שדה"
                    >
                        {[
                            ['name', 'שם'],
                            ['email', 'אימייל'],
                            ['createdAt', 'תאריך יצירה'],
                            ['serial', 'קוד סיריאל'],
                            ['maxUsers', 'מקסימום משתמשים'],
                            ['usedUsers', 'משתמשים שמימשו']
                        ].map(([value, label]) => (
                            <MenuItem key={value} value={value}>{label}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>סדר</InputLabel>
                    <Select
                        value={sortOrder}
                        onChange={e => { setSortOrder(e.target.value); setPage(1); }}
                        label="סדר"
                    >
                        <MenuItem value="asc">עולה</MenuItem>
                        <MenuItem value="desc">יורד</MenuItem>
                    </Select>
                </FormControl>
            </Grid>

            {/* כמות בעמוד */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>כמות בעמוד</Typography>
            </Grid>

            <Grid item xs={6}>
                <FormControl fullWidth size="small">
                    <InputLabel>כמות</InputLabel>
                    <Select
                        value={limit}
                        onChange={e => { setLimit(Number(e.target.value)); setPage(1); }}
                        label="כמות"
                    >
                        {[5, 10, 20, 50, 100].map(num => (
                            <MenuItem key={num} value={num}>{num}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>

            {/* כפתורים */}
            <Grid item xs={12} container spacing={1} justifyContent="flex-end" sx={{ mt: 1 }}>
                <Grid item>
                    <Button variant="contained" onClick={fetchSerials} size="small">חיפוש</Button>
                </Grid>
                <Grid item>
                    <Button variant="outlined" color="secondary" onClick={resetFilters} size="small">איפוס</Button>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default AccessSerialFilterPanel;
